import { BREAKPOINTS } from "@/settings";
import React from "react";
import { NavLink, Outlet } from "react-router";
import { useMediaQuery } from "usehooks-ts";

const LegalCenter: React.FC = () => {
  const isSmallDesktop = useMediaQuery(BREAKPOINTS.SMALL_DESKTOP.query);
  const isMobile = useMediaQuery(BREAKPOINTS.MOBILE.query);

  return (
    <div className="max-w-7xl mx-auto text-white">
      <div className={isSmallDesktop ? "" : "flex"}>
        {isSmallDesktop ? (
          <div className="flex flex-row h-auto sticky top-0 bg-black justify-center">
            <NavLink
              to="faq"
              className={({ isActive }) =>
                `px-4 py-2 rounded text-center ${
                  isActive ? "bg-gray-500" : "hover:bg-gray-300"
                }`
              }
            >
              FAQ
            </NavLink>
            <NavLink
              to="privacy"
              className={({ isActive }) =>
                `text-center px-4 py-2 rounded ${
                  isActive ? "bg-gray-700" : "hover:bg-gray-600"
                }`
              }
            >
              Privacy Policy
            </NavLink>
            <NavLink
              to="tos"
              className={({ isActive }) =>
                `text-center px-4 py-2 rounded ${
                  isActive ? "bg-gray-700" : "hover:bg-gray-600"
                }`
              }
            >
              Terms of Service
            </NavLink>
          </div>
        ) : (
          <div className="w-1/4 h-screen sticky top-12 border-r border-gray-600 pr-4 flex flex-col space-y-2 py-4">
            <NavLink
              to="faq"
              className={({ isActive }) =>
                `text-left px-4 py-2 rounded ${
                  isActive ? "bg-gray-500" : "hover:bg-gray-300"
                }`
              }
            >
              Frequently asked questions
            </NavLink>
            <NavLink
              to="privacy"
              className={({ isActive }) =>
                `text-left px-4 py-2 rounded ${
                  isActive ? "bg-gray-700" : "hover:bg-gray-600"
                }`
              }
            >
              Privacy Policy
            </NavLink>
            <NavLink
              to="tos"
              className={({ isActive }) =>
                `text-left px-4 py-2 rounded ${
                  isActive ? "bg-gray-700" : "hover:bg-gray-600"
                }`
              }
            >
              Terms of Service
            </NavLink>
          </div>
        )}
        <div className={`w-full py-4 ${isMobile ? "px-4" : ""}`}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default LegalCenter;
